import { render, staticRenderFns } from "./JobDependencies.vue?vue&type=template&id=32b85aa0"
import script from "./JobDependencies.vue?vue&type=script&lang=js"
export * from "./JobDependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports